import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/excelInformeStockDosis`, method: 'POST', body: list, token: token})
}